$(function(){

    //----- Image Lazy Load -----
    $("img.lazy").unveil( 100000, function() {
        $(this).load(function() {
            $(this).removeClass('lazy');
        });
    });

    // --- Slider ---
    $("#home-slider").slick({
        dots: true,
        infinite: true,
        fade: true
    });


    //TODO: preopen submenu

    //hide all sub menus
    //$(".sidebar ul li ul").css('display', 'none');

    $(".dropdown-btn.icon-plus").on("click", openSubmenu);

    $(".dropdown-btn.icon-minus").click(function(){
        $(this).removeClass('icon-minus').addClass('icon-plus');
    });

    $("#mobile-menu-link").click(function(){
        $('.sidebar-wrapper')
            .addClass('mobile-show-nav');
        $('body').addClass('no-scroll');
    });

    $("#mobile-hide-nav").click(function(){
        $('.sidebar-wrapper')
            .removeClass('mobile-show-nav');
        $('body').removeClass('no-scroll');
    });



});

function openSubmenu(event){
    console.log("open");

    //Close all other open menus
    $(".dropdown-btn.icon-minus")
        .off().on("click", openSubmenu)
        .removeClass('icon-minus').addClass('icon-plus')
        .parent().parent().find("ul").slideUp(300);

    //Open this menu
    $(this).parent().find(".dropdown-btn.icon-plus")
        .off().on("click", closeSubmenu)
        .removeClass('icon-plus').addClass('icon-minus');
    $(this).parent().parent().find("ul").slideDown(300);
}

//TODO .one() instead of on
function closeSubmenu(event){
    console.log("close");
    $(this).parent().find(".dropdown-btn.icon-minus")
        .off().on("click", openSubmenu)
        .removeClass('icon-minus').addClass('icon-plus');
    $(this).parent().parent().find("ul").slideUp(300);
}

//TODO: fix!
$(function() {
    $(".alt-img").on("click", function(){
        var imgUrl = $("img", this).prop('src');
        //TODO: fading & loading & diff sizes
        $(".main-product-image").prop("src", imgUrl);
        //alert(imgUrl);
    });
});

function addAltImgsEvent() {
    $("#quickViewModal").find(".alt-img").on("click", function(){
        var imgUrl = $("img", this).prop('src');
        //TODO: fading & loading & diff sizes
        $("#quickViewModal").find(".main-product-image").prop("src", imgUrl);
    });
}

